import React, { Component } from "react";
import CountUp from "react-countup";
import _ from "lodash";
import Rating from "react-rating";
import SplitText from "react-pose-text";
import anime from "animejs";
import { withRedux } from "../../hoc";
import { BackgroundImage, Button, StarRating, MyWaypoint, Image } from "../../components";

const bg = `${process.env.PUBLIC_URL}/assets/images/section-2/bgsection2.jpg`;

const { iconStarEmpty, iconStarFull } = StarRating;

const mapStateToProps = ({ language, t, home }) => {
  return {
    language,
    t,
    awards: _.get(home, "data.awards"),
    reviews: _.get(home, "data.reviews"),
    reviewMessage: _.get(home, "data.review_message"),
    reviewRate: _.get(home, "data.review_rate"),
    reviewName: _.get(home, "data.review_name")
  };
};

const actionToProps = {};

@withRedux(mapStateToProps, actionToProps)
export default class Section2 extends Component {
  render() {
    const { t, awards, reviews, reviewMessage, reviewRate, reviewName } = this.props;
    return (
      <BackgroundImage className="section-2" image={bg}>
        <div className="container">
          <MyWaypoint
            anime={[
              () =>
                anime({
                  targets: ".section-2 .conatiner-award img",
                  opacity: [0, 1],
                  translateX: [10, 0],
                  easing: "easeInOutSine",
                  duration: 1000,
                  delay: (el, i) => {
                    return 300 + i * 100;
                  }
                })
            ]}
          >
            <div className="conatiner-award">
              {_.map(awards, (award, index) => {
                return <Image src={award} alt="award" key={index} />;
              })}
            </div>
          </MyWaypoint>
          <div className="container-box-review">
            <div className="row justify-content-center">
              {_.map(reviews, (review, index) => {
                return (
                  <div className="col box-border" key={index}>
                    <div className="box-review">
                      <MyWaypoint>
                        <div className="score">
                          <CountUp end={_.get(review, "rate")} decimals={1} />
                        </div>
                      </MyWaypoint>
                      <MyWaypoint>
                        <h3>
                          {_.get(review, "label.en") && (
                            <SplitText
                              initialPose="exit"
                              pose="enter"
                              charPoses={{
                                exit: { opacity: 0, scale: 0 },
                                enter: {
                                  opacity: 1,
                                  scale: 1,
                                  transition: ({ charInWordIndex }) => ({
                                    type: "spring",
                                    delay: charInWordIndex * 50,
                                    stiffness: 150,
                                    damping: 40
                                  })
                                }
                              }}
                            >
                              {_.get(review, "label.en")}
                            </SplitText>
                          )}
                        </h3>
                      </MyWaypoint>
                      {_.get(review, "rate") && (
                        <React.Fragment>
                          <MyWaypoint
                            anime={[
                              () =>
                                anime({
                                  targets: ".box-review .rating polygon",
                                  fill: ["rgba(0,0,0,0)", "#FFD87F"],
                                  easing: "easeInOutSine",
                                  duration: 1000,
                                  delay: (el, i) => {
                                    return 100;
                                  }
                                })
                            ]}
                          >
                            <Rating
                              className="rating"
                              initialRating={_.get(review, "rate")}
                              readonly={true}
                              emptySymbol={iconStarEmpty()}
                              fullSymbol={iconStarFull()}
                            />
                          </MyWaypoint>
                          <a href={_.get(review, "link")} target="_blank">
                            <Button
                              ghost
                              bordercolor="#ffffff"
                              size="large"
                              style={{ marginTop: 18 }}
                            >
                              Read the Review
                            </Button>
                          </a>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="container-detail">
            <div className="detail-content">
              <MyWaypoint>
                {t(reviewMessage) && (
                  <SplitText
                    initialPose="exit"
                    pose="enter"
                    charPoses={{
                      exit: { opacity: 0.1 },
                      enter: {
                        opacity: 1,
                        delay: ({ charIndex }) => charIndex * 20
                      }
                    }}
                  >
                    {t(reviewMessage)}
                  </SplitText>
                )}
              </MyWaypoint>
            </div>
            <div className="detail-author">
              <p>{reviewName}</p>
              <Rating
                initialRating={_.toNumber(reviewRate)}
                readonly={true}
                emptySymbol={iconStarEmpty()}
                fullSymbol={iconStarFull()}
              />
            </div>
          </div>
        </div>
      </BackgroundImage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section2.js